var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53418 8.28342C1.53418 8.28342 3.8349 3.4519 9.20325 3.4519C14.5716 3.4519 16.8723 8.28342 16.8723 8.28342C16.8723 8.28342 14.5716 13.1149 9.20325 13.1149C3.8349 13.1149 1.53418 8.28342 1.53418 8.28342Z",
    stroke: "white",
    strokeWidth: 1.38043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20355 10.3536C10.4742 10.3536 11.5043 9.42652 11.5043 8.28293C11.5043 7.13934 10.4742 6.21228 9.20355 6.21228C7.9329 6.21228 6.90283 7.13934 6.90283 8.28293C6.90283 9.42652 7.9329 10.3536 9.20355 10.3536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewWhite);
export default __webpack_public_path__ + "static/media/previewWhite.c0863a04a597ddebf8497aa58e6905d2.svg";
export { ForwardRef as ReactComponent };